import { Menu } from "lucide-react";
import { useNavigate } from "react-router";
import { useAppDispatch, useAppSelector } from "../../../import";
import { logoutAgent } from "../../../store/agent/auth-slice";
import BirthdayBell from "./birthdayBell";
import KycExpiredBell from "./kycExpiredBell";
import ChatNavButton from "../../common/chat/chatNavButton";

interface AgentNavbarProps {
  toggleSidebar: () => void;
  isSidebarOpen: boolean;
}

const AgentNavbar = ({ toggleSidebar }: AgentNavbarProps) => {
  const { user } = useAppSelector((state) => state.agentAuth);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logoutAgent());
    navigate("/login");
  };

  return (
    <header className="flex items-center justify-between border-b border-[#2A2622] bg-[#090807] px-4 py-3">
      <button
        className="lg:hidden p-1.5 rounded-lg text-[#D19A66] hover:bg-[#B87F4B]/10"
        onClick={toggleSidebar}
        aria-label="Open menu"
      >
        <Menu size={20} />
      </button>

      <div className="ml-auto flex items-center gap-3">
        <ChatNavButton />
        <BirthdayBell />
        <KycExpiredBell />
        <span className="text-sm text-[#ADA79A]">
          {user?.name}
        </span>
        <button
          onClick={handleLogout}
          className="rounded-lg border border-[#B87F4B]/25 px-3 py-1.5 text-xs font-medium text-[#D19A66] hover:bg-[#B87F4B]/10 transition-colors"
        >
          Sign out
        </button>
      </div>
    </header>
  );
};

export default AgentNavbar;
